import Image from "next/image";
import VideoPlay from "./VideoPlay";

export default function VideoThumb({image, imageAlt = '', className, showLabel = false, fullMobile = false, onPlay}) {
    const isPlayable = !!onPlay;

    return (
        <div
            className={`relative overflow-hidden ${fullMobile ? 'sm:rounded-lg' : 'rounded-lg'} group will-change-transform ${isPlayable ? 'cursor-pointer' : ''} ${className}`}
            onClick={onPlay}>

            <Image src={image}
                   alt={imageAlt}
                   className={`h-full object-cover ${isPlayable ? 'group-hover:scale-110 group-hover:-rotate-2 transition-transform ease-out duration-1000' : ''}`}
            />

            {isPlayable && <VideoPlay showLabel={showLabel} onPlay={onPlay}/>}
        </div>
    )
}
